import { getQaSelector } from '../../../../../../utils/common'
import { Skeleton } from '../../../../../Skeleton'
import {
  APPLICANT_BOARD_SKELETON_CARDS,
  QA_NAME_APPLICANT_BOARD_SKELETON_CARD,
} from '../../RentalPortalApplicantBoard.constants'

import * as styles from './RentalPortalApplicantBoardColumnSkeleton.module.css'

function RentalPortalApplicantBoardColumnSkeleton() {
  return APPLICANT_BOARD_SKELETON_CARDS.map(skeletonCard => (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_BOARD_SKELETON_CARD })}
      className={styles.RentalPortalApplicantBoardColumnSkeleton}
      key={skeletonCard}
    >
      <Skeleton className={styles.title} />
      <Skeleton className={styles.meta} />
    </div>
  ))
}

export default RentalPortalApplicantBoardColumnSkeleton
